import { AutoFixHigh } from "@mui/icons-material";
import { Button } from "@mui/material";
import { generateStrongPassword } from "../utils/passwordGenerator";

function GerarSenhaButton({ onGenerate, disabled = false, fullWidth = false }) {
  const handleGerar = () => {
    onGenerate(generateStrongPassword(16));
  };

  return (
    <Button
      type="button"
      variant="outlined"
      size="medium"
      disabled={disabled}
      fullWidth={fullWidth}
      startIcon={<AutoFixHigh />}
      onClick={handleGerar}
      sx={{ textTransform: "none" }}
    >
      Gerar Senha Forte
    </Button>
  );
}

export default GerarSenhaButton;
